export const categories = [
  {
    id: "cat-1",
    name: "女王调教入门",
    slug: "queen-domination-basics",
    description: "从零开始了解女王调教的世界，掌握支配与臣服关系的基本概念、核心原则与入门实践方法。",
    icon: "ri-graduation-cap-line",
  },
  {
    id: "cat-2",
    name: "支配与臣服心理",
    slug: "dominance-submission-psychology",
    description: "深入探讨支配者与臣服者的心理动因、情感连接机制，以及如何在D/s关系中建立深层次的心理互动。",
    icon: "ri-brain-line",
  },
  {
    id: "cat-3",
    name: "安全规范与边界",
    slug: "safety-rules-boundaries",
    description: "全面了解女王调教中的安全准则、边界设定与知情同意原则，确保每一次互动都在安全框架内进行。",
    icon: "ri-shield-check-line",
  },
  {
    id: "cat-4",
    name: "女王支配风格",
    slug: "queen-domination-styles",
    description: "探索不同类型的女王支配风格，从温柔引导到严厉管教，找到最适合您个性的支配方式。",
    icon: "ri-vip-crown-line",
  },
  {
    id: "cat-5",
    name: "调教实操技巧",
    slug: "practical-techniques",
    description: "系统学习女王调教的各类实操技巧，包括语言命令、行为训练、情境构建等具体操作方法。",
    icon: "ri-tools-line",
  },
];

export const getCategoryBySlug = (slug: string) => categories.find((c) => c.slug === slug);
export const getCategoryById = (id: string) => categories.find((c) => c.id === id);